import { getOrderStatusColorClassName } from '@trukt/tailwind-utils/getOrderStatusColorClassName';
import { getJobStatusColorClassName } from '@trukt/tailwind-utils/getJobStatusColorClassName';
import { OrderJobStatusPillProps } from './OrderJobStatusPill.types';
import { StatusPill } from '../StatusPill';
import { OrderStatusLiterals } from '@trukt/types/Order';
import { JobStatusLiterals } from '@trukt/types/Job';

export const OrderJobStatusPill = ({ variant, status, requestsCount }: OrderJobStatusPillProps) => {
  const bgColorClassName =
    variant === 'order'
      ? getOrderStatusColorClassName(status as OrderStatusLiterals, 'bg')
      : getJobStatusColorClassName(status as JobStatusLiterals, 'bg');

  return (
    <StatusPill
      status={status}
      bgColorClassName={bgColorClassName}
      count={requestsCount && requestsCount > 0 ? String(requestsCount) : undefined}
    />
  );
};
